





















































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import ComBoxFactoryResetDialogComponent from "@/components/combox/ComBoxFactoryResetDialog.vue";
import { SnackbarModule } from "@/store/modules/SnackbarModule";

import { ComBox, getMcuResetSourcesString } from "@/data/models/ComBox";
import { formatKWh } from "@/utils/LocalisationHelper";
import { formatIresBatteryStatus } from "@/data/models/IresDevice";
import {
  createFactoryResetRequest,
  createRestartComBoxCommand,
} from "@/utils/combox/commands/ComBoxCommands";
import { viewIresInfoClientAccess } from "@/permissions/ClientPermissions";
import { hasCapability, DeviceCapability } from "@/data/models/DeviceCapability";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "factory-reset-dialog": ComBoxFactoryResetDialogComponent,
  },
})
export default class ComBoxSettingsComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  @Ref("factoryResetDialog")
  factoryResetDialogComponent!: ComBoxFactoryResetDialogComponent;

  showIresInfo = viewIresInfoClientAccess();

  @Prop()
  comBox!: ComBox;

  get hasDisplay() {
    return hasCapability(this.comBox, DeviceCapability.HAS_DISPLAY);
  }

  get currentMeterReadingInKwh() {
    return formatKWh(this, this.comBox.comBoxStatus.currentMeterReadingInKwh);
  }

  get comBoxBatteryStatus() {
    return formatIresBatteryStatus(
      this,
      this.comBox.comBoxStatus.batteryVoltage
    );
  }

  get mcuResetSource() {
    return getMcuResetSourcesString(this, this.comBox);
  }

  async show() {
    this.baseDialogComponent.show({
      title: this.$t("comBoxSettings.title", [this.comBox.serialNo]).toString(),
      positiveButtonText: null,
      persistent: false,
    });
  }

  async onRestartComBox() {
    const confirmed = await this.confirmationDialogComponent.show({
      title: this.$t("comBoxSettings.restartConfirmTitle", [this.comBox.serialNo]).toString(),
      message: this.$t("comBoxSettings.restartConfirmMessage").toString(),
      acceptMessage: this.$t("panelDetail.actions.restart").toString(),
    });
    if (!confirmed) {
      return;
    }

    await createRestartComBoxCommand(this.comBox.serialNo);
    SnackbarModule.showSuccess({ key: "panelControl.queuedRequestRestartPanel" });
  }

  async onFactoryReset() {
    const flags = await this.factoryResetDialogComponent.show(this.comBox.serialNo);

    if (flags === null) {
      return;
    }

    try {
      await createFactoryResetRequest(this.comBox.serialNo, flags);
      SnackbarModule.showSuccess({ key: "panelControl.queuedRequestFactoryReset" });
    } catch (e) {
      SnackbarModule.showError({ key: "comBoxSettings.factoryReset.queueFailed" });
    }
  }
}
